import SDIcon from './SDIcon'

const IconCarbonHeadphones = (props) => (
  <SDIcon title='Headphones' {...props}>
    <path d='M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z' />
  </SDIcon>
)

export default IconCarbonHeadphones
